function NotFound() {
    return (
      <div className="container mt-5 text-center">
        <h1>404 - Página no encontrada</h1>
        <p>La página que estás buscando no existe.</p>
      </div>
    )
  }
  
  export default NotFound